var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showEdits ||
    _vm.showArchive ||
    _vm.showUnarchive ||
    _vm.showPromote ||
    _vm.showDelete
    ? _c(
        "button",
        {
          class: [`additional-options`, `project-actions`],
          on: { click: _vm.toggleActions }
        },
        [
          _c("img", {
            staticClass: "project-actions",
            attrs: { src: require("@/drc/assets/icons/3dots.svg"), alt: "..." }
          }),
          _vm.openAdditionalOptions
            ? _c(
                "div",
                { staticClass: "additional-option-popup project-actions" },
                [
                  _vm.showEdits
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-button option-button-edit project-actions",
                          on: { click: _vm.edit }
                        },
                        [
                          _c("img", {
                            staticClass: "project-actions",
                            attrs: {
                              src: require("@/common/assets/icons/edit-blue-2.svg"),
                              alt: "edit"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("controlPanel.landingPage.buttons.edit")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showArchive
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-button option-button-archive project-actions",
                          on: { click: _vm.archive }
                        },
                        [
                          _c("img", {
                            staticClass: "project-actions",
                            attrs: {
                              src: require("@/common/assets/icons/archive-blue.svg"),
                              alt: "share"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "controlPanel.landingPage.buttons.archive"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showUnarchive
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-button option-button-unarchive project-actions",
                          on: { click: _vm.unarchive }
                        },
                        [
                          _c("img", {
                            staticClass: "project-actions",
                            attrs: {
                              src: require("@/common/assets/icons/unarchive.svg"),
                              alt: "unarchive"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "controlPanel.landingPage.buttons.unarchive"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showPromote
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-button option-button-promote project-actions",
                          on: { click: _vm.promote }
                        },
                        [
                          _c("img", {
                            staticClass: "project-actions",
                            attrs: {
                              src: require("@/common/assets/icons/promote.svg"),
                              alt: "promote"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "controlPanel.landingPage.buttons.promote"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showDelete
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-button option-button-delete project-actions",
                          on: { click: _vm.deleteProject }
                        },
                        [
                          _c("img", {
                            staticClass: "project-actions",
                            attrs: {
                              src: require("@/common/assets/icons/delete-red-2.svg"),
                              alt: "delete"
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "controlPanel.landingPage.buttons.delete"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }